<script setup lang="ts">
import type { KanbanLogActor } from '@entities/kanban-comment'
import type { TutorKanbanStage } from '@brighterly/lib-core-types/tutor-kanban/enums'

import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { KanbanLogItemInfo } from '@widgets/kanban-comments'
import { useListsStore } from '@shared/model'
import { AppText } from '@shared/ui/typography'
import { IconContainer } from '@shared/ui/other'
import { BadgeKanbanStageStatus } from '@shared/ui/kanban'

import { TUTOR_KANBAN_STAGE_COLOR } from '../../config/tutor-kanban-stage-color.const'

defineOptions({
  name: 'TutorKanbanLogStage',
})

defineProps<{
  actor: KanbanLogActor | null
  oldValue: string
  value: string
}>()

const listsStore = useListsStore()
const stageList = listsStore.getTutor?.stage ?? {}
</script>

<template>
  <div class="kanban-log-field">
    <KanbanLogItemInfo
      v-if="actor"
      label="change stage"
      :actor="actor"
    />
    <AppText
      v-else
      name="body2"
      color="slate-400"
      class="unassigned"
    >
      changed automatically
    </AppText>
    <div class="kanban-log-field__row">
      <BadgeKanbanStageStatus
        v-if="oldValue"
        :text="stageList[oldValue] ?? oldValue"
        :color="TUTOR_KANBAN_STAGE_COLOR[oldValue as TutorKanbanStage]"
      />
      <IconContainer v-if="oldValue">
        <FontAwesomeIcon :icon="faArrowRight" />
      </IconContainer>
      <BadgeKanbanStageStatus
        :text="stageList[value] ?? value"
        :color="TUTOR_KANBAN_STAGE_COLOR[value as TutorKanbanStage]"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="@shared/ui/kanban/styles/_kanban-log-field.scss" />